import React from "react";
import styled from "styled-components";
import { Body3 } from "../../../../assets/styles/Typography";
import { palette } from "../../../../assets/styles/Palette";
import { CheckBoxButton } from "../../../../assets/styles/InputStyle";

// 이미지 import 추가
import DesignConceptRed from "../../../../assets/images/Design_Concept_Red.png";
import DesignConceptBlue from "../../../../assets/images/Design_Concept_Blue.png";
import DesignConceptBlack from "../../../../assets/images/Design_Concept_Black.png";

const OrganismDesignConceptSelector = ({
  concepts = [],
  selectedConcepts = [],
  onSelect,
  disabled = false,
}) => {
  const isSelected = (conceptId) => {
    return selectedConcepts.includes(conceptId);
  };

  const isDisabled = (concept) => {
    return (
      disabled ||
      // concept.name === "기본 심플형" ||
      concept.name === "어두운 기본형"
    );
  };

  const handleToggle = (conceptId, fromCheckbox = false) => {
    // if (!isDisabled(concepts.find(c => c.id === conceptId))) {
      onSelect(conceptId);
    // }
  };

   // 컨셉트별 이미지를 반환하는 함수
  const getPreviewImage = (conceptName) => {
    switch(conceptName) {
      case "기본 심플형":
        return DesignConceptRed;
      case "어두운 기본형":
        return DesignConceptBlack;
      case "소프트 블루형":
        return DesignConceptBlue;
      default:
        return DesignConceptRed;
    }
  };
  return (
    <ConceptSelectorWrapper>
      <ConceptGrid>
        {concepts.map((concept) => (
          <ConceptCard
            key={concept.id}
            selected={isSelected(concept.id)}
            // disabled={isDisabled(concept)}
            onClick={(e) => {
              // 체크박스에서 온 클릭이 아닐 때만 실행
              if (e.target.type !== 'checkbox') {
                handleToggle(concept.id);
              }
            }}
          >
            <ConceptHeader>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "8px",
                  width: "100%",
                }}
              >
                <CheckBoxButton
                  id={concept.id}
                  name={concept.id}
                  checked={isSelected(concept.id)}
                  onChange={() => handleToggle(concept.id, true)}
                  // disabled={isDisabled(concept)}
                  style={{ cursor: "pointer", marginTop: "2px" }}
                />
                <div style={{ flex: 1, textAlign: "left" }}>
                  <Body3 color="gray800" style={{ fontWeight: "600" }}>
                    {concept.name}
                  </Body3>
                </div>
              </div>
            </ConceptHeader>
            <ConceptPreview>
              <PreviewImage
                src={getPreviewImage(concept.name)}
                alt={concept.name}
              />
            </ConceptPreview>
            <ConceptDescription>
              <Body3
                color="gray500"
                style={{ textAlign: "left", lineHeight: "1.4" }}
              >
                {concept.description}
              </Body3>
            </ConceptDescription>
          </ConceptCard>
        ))}
      </ConceptGrid>
    </ConceptSelectorWrapper>
  );
};

export default OrganismDesignConceptSelector;

const ConceptSelectorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ConceptGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
`;

const ConceptCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  border: 1px solid
    ${(props) => {
      if (props.disabled) return "#E0E4EB";
      return props.selected ? palette.primary : "#E0E4EB";
    }};
  border-radius: 8px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: all 0.2s ease;
  background: ${(props) => {
    if (props.disabled) return "#F8F9FA";
    return props.selected ? "rgba(34, 111, 255, 0.05)" : "white";
  }};
  position: relative;
  opacity: ${(props) => (props.disabled ? "0.5" : "1")};

  &:hover {
    border-color: ${(props) => (props.disabled ? "#E0E4EB" : palette.primary)};
    background: ${(props) =>
      props.disabled ? "#F8F9FA" : "rgba(34, 111, 255, 0.02)"};
  }
`;

const ConceptHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  margin-bottom: 12px;
`;

const ConceptInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
`;

const ConceptDescription = styled.div`
  margin-top: 12px;
`;

const ConceptPreview = styled.div`
  width: 100%;
  height: 132px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e9ecef;
`;

// 스타일드 컴포넌트 추가
const PreviewImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
`;
